import _defineProperty from '../../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import { makeStyles } from '@material-ui/core';
import PropTypes__default from 'prop-types';
import CustomButton from '../custom-button/CustomButton.js';
import React__default from 'react';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';

var useStyles = makeStyles(function (theme) {
  return {
    actions: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-end"
    },
    reverseActions: {
      flexDirection: "row-reverse",
      justifyContent: "flex-start"
    },
    firstButton: {},
    secondButton: {
      marginLeft: theme.spacing(2)
    }
  };
});
var CustomCTA = function CustomCTA(_ref) {
  var firstTitle = _ref.firstTitle,
    firstActionHandler = _ref.firstActionHandler,
    secondTitle = _ref.secondTitle,
    secondActionHandler = _ref.secondActionHandler,
    containerClassNameOverride = _ref.containerClassNameOverride,
    firstSize = _ref.firstSize,
    firstColor = _ref.firstColor,
    firstVariant = _ref.firstVariant,
    firstClassNameOverride = _ref.firstClassNameOverride,
    firstDisableElevation = _ref.firstDisableElevation,
    firstLoading = _ref.firstLoading,
    firstE2eId = _ref.firstE2eId,
    secondSize = _ref.secondSize,
    secondColor = _ref.secondColor,
    secondVariant = _ref.secondVariant,
    secondClassNameOverride = _ref.secondClassNameOverride,
    secondDisableElevation = _ref.secondDisableElevation,
    secondLoading = _ref.secondLoading,
    secondStartIcon = _ref.secondStartIcon,
    secondE2eId = _ref.secondE2eId,
    reverseMobileOrder = _ref.reverseMobileOrder;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.actions, _defineProperty({}, classes.reverseActions, reverseMobileOrder), _defineProperty({}, containerClassNameOverride, containerClassNameOverride))
  }, /*#__PURE__*/React__default.createElement(Box, {
    clone: true,
    order: reverseMobileOrder && 2 || 1
  }, /*#__PURE__*/React__default.createElement(CustomButton, {
    "e2e-id": firstE2eId || "",
    variant: firstVariant,
    className: clsx(classes.firstButton, _defineProperty({}, firstClassNameOverride, firstClassNameOverride)),
    size: firstSize,
    color: firstColor,
    onClick: firstActionHandler,
    disableElevation: firstDisableElevation,
    loading: firstLoading
  }, firstTitle)), /*#__PURE__*/React__default.createElement(Box, {
    clone: true,
    order: reverseMobileOrder && 1 || 2
  }, /*#__PURE__*/React__default.createElement(CustomButton, {
    variant: secondVariant,
    className: clsx(classes.secondButton, _defineProperty({}, secondClassNameOverride, secondClassNameOverride)),
    size: secondSize,
    color: secondColor,
    onClick: secondActionHandler,
    disableElevation: secondDisableElevation,
    loading: secondLoading,
    startIcon: secondStartIcon,
    "e2e-id": secondE2eId || ""
  }, secondTitle)));
};
CustomCTA.defaultProps = {
  firstSize: "large",
  firstVariant: "outlined",
  firstDisableElevation: false,
  firstLoading: false,
  secondSize: "large",
  secondVariant: "contained",
  secondDisableElevation: true,
  secondLoading: false,
  reverseMobileOrder: false
};
CustomCTA.propTypes = {
  // Required Properties
  firstTitle: PropTypes__default.string.isRequired,
  firstActionHandler: PropTypes__default.any.isRequired,
  secondTitle: PropTypes__default.string.isRequired,
  secondActionHandler: PropTypes__default.any.isRequired,
  // Optional Properties
  containerClassNameOverride: PropTypes__default.string,
  firstSize: PropTypes__default.string,
  firstColor: PropTypes__default.string,
  firstVariant: PropTypes__default.string,
  firstClassNameOverride: PropTypes__default.string,
  firstDisableElevation: PropTypes__default.bool,
  firstLoading: PropTypes__default.bool,
  firstE2eId: PropTypes__default.string,
  secondSize: PropTypes__default.string,
  secondVariant: PropTypes__default.string,
  secondColor: PropTypes__default.string,
  secondClassNameOverride: PropTypes__default.string,
  secondDisableElevation: PropTypes__default.bool,
  secondLoading: PropTypes__default.bool,
  secondStartIcon: PropTypes__default.object,
  reverseMobileOrder: PropTypes__default.bool,
  secondE2eId: PropTypes__default.string
};

export { CustomCTA as default };
//# sourceMappingURL=CustomCTA.js.map
